import { CheckOutlined, ExclamationOutlined } from '@ant-design/icons';
import { Col, Input, Row } from 'antd';
import { Rule } from 'antd/lib/form';
import React, { FC, Fragment, useMemo } from 'react';

import { JTextField } from '../../../JForm';
import { InfoField } from '../InfoField';
import { DEFAULT_ROW_GUTTER } from '../../constants';
import { JTextProps } from '../../models';
import { getValidationLabels, validators } from '../../validators';
import { useCompositorContext } from '../CompositorProvider';
import { FormItem, withFormItem } from '../FormItem';


export const JTextWithoutFormItem: FC<JTextProps> = (props) => {
    const hasSuffix = props.description || props.infoFileURL
    return (
        <Input
            autoComplete={props.autocomplete}
            aria-describedby={props.validationMessage}
            type={props.htmlType}
            onChange={props.onChange}
            value={props.value as string}
            suffix={(
                <Fragment>
                    {
                        props.status === 'VALID' && (
                            <CheckOutlined aria-hidden={true}/>
                        )
                    }
                    {
                        props.status === 'INVALID' && (
                            <ExclamationOutlined aria-hidden={true}/>
                        )
                    }
                    {
                        hasSuffix && (
                            <InfoField tooltipText={props.description} fileURL={props.infoFileURL} />
                        )
                    }
                </Fragment>
            )}
            disabled={props.disabled}
            placeholder={props.placeholder}
        >
        </Input>
    )
}

export const JTextDefault = withFormItem(JTextWithoutFormItem)

export const JText: FC<JTextProps> = (props) => {
    return (
        <Fragment>
            {!props?.confirmed ?
                <JTextDefault {...props} />
                :
                <JTextWithConfirm {...props} />
            }
        </Fragment>
    )
}


const JTextWithConfirm: FC<JTextProps> = props => {
    const { translate, confirmsColProps } = useCompositorContext();

    const translateLabels = useMemo(() => getValidationLabels(props.label, translate, {
        ignoreRequired: !props.mandatory
    }), [props.mandatory])

    const rules: Rule[] = useMemo(() => [validators.confirmed(props.name, translateLabels.noMatch)], [translateLabels]);

    return (
        <Fragment>
            <Row gutter={DEFAULT_ROW_GUTTER}>
                <Col {...confirmsColProps}>
                    <JTextDefault {...props} />
                </Col>
                <Col {...confirmsColProps}>

                    <FormItem
                        fieldProps={props}
                        name={['formCompositorConfirms', ...props.name]}
                        rules={rules}
                    >
                        <JTextField
                            autoComplete={props.autocomplete}
                            errorMessage={props.validationMessage}
                            type={props.htmlType}
                            name='confirmed'
                            disabled={props.disabled}
                            placeholder={translateLabels.confirm}
                        />
                    </FormItem>
                </Col>
            </Row>
        </Fragment>
    )

}

